import { render, staticRenderFns } from "./RelationVisa.vue?vue&type=template&id=3aa8d42f&"
import script from "./RelationVisa.vue?vue&type=script&lang=js&"
export * from "./RelationVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports